<template>
  <div class="card-container">
    <div class="title">
      <div>{{ title }}</div>
      <slot name="custom-header"></slot>
    </div>
    <slot></slot>
  </div>
</template>

<script setup>
defineProps({
  title: {
    type: String,
    required: true,
    default: '',
  },
})
</script>

<style scoped lang="less">
.card-container {
  background-color: #fff;
  border-radius: 8px;
  padding: 8px 16px 8px 16px;
  margin-bottom: 16px;
  overflow: hidden;
  width: 100%;
  box-sizing: border-box;
  .title {
    width: 100%;
    height: 38px;
    line-height: 38px;
    font-size: 14px;
    font-weight: 500;
    display: flex;
    justify-content: space-between;
    color: rgba(0, 0, 0, 0.9);
    margin-bottom: 8px;
  }
}
</style>
